import { render, staticRenderFns } from "./affiliate.vue?vue&type=template&id=3ddc7f80&scoped=true&"
import script from "./affiliate.vue?vue&type=script&lang=js&"
export * from "./affiliate.vue?vue&type=script&lang=js&"
import style0 from "./affiliate.vue?vue&type=style&index=0&id=3ddc7f80&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddc7f80",
  null
  
)

export default component.exports